var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationScribbleCurveLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 219 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 68.363c14.627 2.875 29.943 3.398 44.054-1.22 14.11-4.619 26.931-14.814 32.524-28.757 3.098-7.843 3.528-17.428-1.549-24.05-5.162-6.624-16.95-7.495-21.166-.262-5.077 8.801 4.044 19.17 13.164 23.44 28.91 13.595 66.942 2.615 84.15-24.486-3.269 18.387 2.668 38.168 15.488 51.675C180.399 78.21 199.759 85.007 218 82.48"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationScribbleCurveLine);
export default __webpack_public_path__ + "static/media/illustration-scribble-curve-line.6ae9d3c02cea4493cbea10e2e9cb1a52.svg";
export { ForwardRef as ReactComponent };